export default {
      id: "i-main-advantages-03-usage",
      viewBox: "0 0 40 47",
      url: __webpack_public_path__ + "img/sprite.svg#i-main-advantages-03",
      toString: function () {
        return this.url;
      }
    }